import { render } from "./Footer.vue?vue&type=template&id=2a56870e"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/SANDRACANIZAREZ/mi-stock-sandracanizares-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__